import FroalaEditor from "froala-editor";

import "froala-editor/js/plugins/link.min.js";
import "froala-editor/js/plugins/paragraph_format.min.js";
import "froala-editor/js/plugins/paragraph_style.min.js";

document.addEventListener("turbo:load", () => {
  let froalableElements = document.querySelectorAll(
    "[data-behavior=minimal-wysiwyg]"
  );

  setTimeout(() => {
    froalableElements.forEach((el) => setFroalaEditor(el));
  }, 100);

  const setFroalaEditor = (element) => {
    new FroalaEditor(element, {
      key: "aLF3c1C10C5E6C2E3F2C-7wjhnxlnbmA3md1C-13mD6F5F4H4E1B9A8C3C4F5==",
      placeholderText: element.dataset.placeholder || "Tu respuesta...",
      width: element.dataset.width,
      height: element.dataset.height || 300,
      attribution: false,
      emoticonsUseImage: false,
      linkAttributes: {
        rel: "ugc",
      },
      linkAlwaysBlank: true,
      linkAlwaysNoFollow: true,
      linkNoOpener: false,
      linkNoReferrer: false,
      linkText: true,
      toolbarButtons: {
        moreText: {
          buttons: ["bold", "italic", "underline"],
        },
        moreRich: {
          buttons: ["insertLink", "emoticons"],
        },
        moreMisc: {
          buttons: [
            "audio",
            "undo",
            "redo",
            "fullscreen",
            "print",
            "spellChecker",
            "selectAll",
          ],
        },
      },
    });
  };
});
